import { MouseEvent } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

interface StockBySKUTablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

export function StockBySKUTablePaginationActions({
  count,
  page,
  rowsPerPage,
  onPageChange,
}: StockBySKUTablePaginationActionsProps) {
  const totalPages = Math.ceil(count / rowsPerPage);

  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const isFirstPage = page === 0;
  const isLastPage = page >= totalPages - 1;

  return (
    <div className='flex items-center gap-2'>
      <button
        onClick={handleBackButtonClick}
        disabled={isFirstPage}
        aria-label='previous page'
        className={`p-1.5 rounded-md transition-colors ${
          isFirstPage
            ? 'text-gray-300 cursor-not-allowed'
            : 'text-gray-600 hover:bg-gray-100 cursor-pointer'
        }`}
        type='button'
      >
        <ChevronLeftIcon className='h-5 w-5' />
      </button>

      <span className='text-sm text-gray-600 min-w-[4rem] text-center'>
        Page {page + 1} of {totalPages || 1}
      </span>

      <button
        onClick={handleNextButtonClick}
        disabled={isLastPage}
        aria-label='next page'
        className={`p-1.5 rounded-md transition-colors ${
          isLastPage
            ? 'text-gray-300 cursor-not-allowed'
            : 'text-gray-600 hover:bg-gray-100 cursor-pointer'
        }`}
        type='button'
      >
        <ChevronRightIcon className='h-5 w-5' />
      </button>
    </div>
  );
}
